import { useState } from 'react';
import { C, DEGRADE_ACTION } from '../../theme';
import { Champ, styleChamp } from './champs';
import { jourDe } from '../format';
import type { ModificationTache } from '@colette/shared';
import type { Tache } from '../../api/types';

/** Modifier une tache existante : son titre et son echeance. N'envoie que ce qui change. */
export function FormulaireTache({
  tache,
  fuseau,
  occupe,
  onEnregistrer,
  onAnnuler,
}: {
  tache: Pick<Tache, 'title' | 'dueAt'>;
  fuseau: string;
  occupe: boolean;
  onEnregistrer: (modification: ModificationTache) => void;
  onAnnuler: () => void;
}) {
  const echeanceInitiale = tache.dueAt === null ? '' : jourDe(tache.dueAt, fuseau);
  const [titre, setTitre] = useState(tache.title);
  const [echeance, setEcheance] = useState(echeanceInitiale);

  const enregistrer = () => {
    if (occupe) return;
    const modification: ModificationTache = {};
    if (titre.trim() !== tache.title) modification.title = titre.trim();
    if (echeance !== echeanceInitiale) modification.dueDate = echeance === '' ? null : echeance;
    if (Object.keys(modification).length === 0) {
      onAnnuler();
      return;
    }
    onEnregistrer(modification);
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        enregistrer();
      }}
      style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%' }}
    >
      <Champ libelle="Titre">
        <input
          value={titre}
          onChange={(e) => setTitre(e.target.value)}
          aria-label="Titre de la tâche"
          style={styleChamp}
        />
      </Champ>
      <Champ libelle="À faire avant">
        <input
          type="date"
          value={echeance}
          onChange={(e) => setEcheance(e.target.value)}
          aria-label="Échéance de la tâche"
          style={styleChamp}
        />
      </Champ>
      <div style={{ fontSize: 12, color: C.tertiaire, marginTop: -4 }}>
        Sans date, la tâche passe dans « Sans date ».
      </div>
      <BoutonsFormulaire occupe={occupe} onAnnuler={onAnnuler} ariaAnnuler="Annuler la modification" />
    </form>
  );
}

/** Les deux boutons de bas de formulaire, identiques partout. */
export function BoutonsFormulaire({
  occupe,
  onAnnuler,
  ariaAnnuler,
}: {
  occupe: boolean;
  onAnnuler: () => void;
  ariaAnnuler: string;
}) {
  return (
    <div style={{ display: 'flex', gap: 8 }}>
      <button
        type="submit"
        disabled={occupe}
        className="pressable"
        style={{
          flex: 1,
          height: 42,
          border: 'none',
          borderRadius: 12,
          background: occupe ? C.inactif : DEGRADE_ACTION,
          color: '#FFFFFF',
          fontSize: 14,
          fontWeight: 800,
          fontFamily: 'inherit',
          cursor: occupe ? 'default' : 'pointer',
        }}
      >
        {occupe ? 'Enregistrement…' : 'Enregistrer'}
      </button>
      <button
        type="button"
        className="pressable"
        aria-label={ariaAnnuler}
        onClick={onAnnuler}
        style={{
          height: 42,
          padding: '0 16px',
          border: `1px solid ${C.bordure}`,
          borderRadius: 12,
          background: C.carte,
          color: C.secondaire,
          fontSize: 14,
          fontWeight: 700,
          fontFamily: 'inherit',
          cursor: 'pointer',
        }}
      >
        Annuler
      </button>
    </div>
  );
}
